import React from "react"
import { Redirect } from "react-router-dom"
import Config, { ActiveClient } from "../config";

// Master File
import VendorMaster from "../pages/Masters/Vendor-Master/VendorMaster"
import CustomerMaster from "../pages/Masters/Customer-Master/CustomerMaster"
import LocationMaster from "../pages/Masters/Location-Master/LocationMaster"
import SalesExecutiveMaster from "../pages/Masters/Sales-Executive-Master/SalesExecutiveMaster"
import SalesExecutiveGroupMaster from "../pages/Masters/Sales-Assistant-Group-Master/salesAssistantGroup"
import CustomerGroupMaster from "../pages/Masters/Customer-Group-Master/CustomerGroupMaster"
import CustomerDiscountGroupMaster from "../pages/Masters/Customer-Discount-Group-Master/CustomerDiscountGroupMaster"
import PaymentMode from "../pages/Masters/PaymentModeHed/PaymentMode"
import VendorGroup from "../pages/Masters/Vendor-Group/VendorGroup"
import TaxMaster from "../pages/Masters/Tax_Master/TaxMaster"
import UnitMaster from "../pages/Masters/Unit-Of-Measure-Master/UnitOfMeasureMaster"
import ProductMaster from "../pages/Masters/Product-Master/ProductMaster"
import TransactionTypeMaster from "../pages/Masters/Transaction-Types-Master/TransactionTypeMaster"
import GroupMaster from "../pages/Masters/Group-Master/GroupMaster"
import AreaMaster from "../pages/Masters/Supplier-Area-Master/AreaMaster"
import SuplierTypeMaster from "../pages/Masters/Suplier-Type-Master/suplierTypeMaster"
import SuplierCategoryMaster from "../pages/Masters/Suplier-Category-Master/suplierCategoryMaster"
import DesignationMaster from "../pages/Masters/Designation-Master/DesignationMaster"
import ProfessionMaster from "../pages/Masters/Profession-Master/ProfessionMaster"
import LanguageMaster from "../pages/Masters/Language-Master/LanguageMaster"
import EthnicityMaster from "../pages/Masters/Ethnicity-Master/EthnicityMaster"
import ReligionMaster from "../pages/Masters/Religion-Master/ReligionMaster"
import GroupMasterSetup from "../pages/Utility/Group-Setup/GroupMasterSetup"
import LoyaltyGroupMaster from "../pages/Masters/Loyalty-Group-Master/LoyaltyGroupMaster"
import PriceModeMaster from "../pages/Masters/Price-Mode-Master/PriceModeMaster"
import PurchasingModeMaster from "../pages/Masters/Purchasing-Mode-Master/PurchasingModeMaster"
import TitlesMaster from "../pages/Masters/Titles-Master/TitlesMaster"
import ProviderMaster from "../pages/Masters/Provider-Master/ProviderMaster"
import UserMaster from "../pages/Utility/User-Master/UserMaster"
import UserGroupMaster from "../pages/Utility/User-Groups-Master/UserGroupsMaster"
import ReasonTypesMaster from "../pages/Masters/Reason-Types-Master/ReasonTypesMaster"
import CompanyMaster from "../pages/Masters/Company-Master/CompanyMaster"
import Transactions from "../pages/Transactions/Transaction/Transaction"
import StockFreeze from "../pages/Transactions/StockFreeze/StockFreeze"
import SizeMaster from "../pages/Masters/Size-Master/SizeMaster"
import ColorMaster from "../pages/Masters/Color-Master/ColorMaster"
import PromotionMaster from "pages/Masters/Promotion-Master/PromotionMaster"
import PromotionGroupMaster from "pages/Masters/Promotion-Group-Master/PromotionGroupMaster"
import CustomerBundleMaster from "pages/Masters/Customer-Bundle/CustomerBundleMaster"
import SupplierBundleMaster from "../pages/Masters/Supplier-Bundle-Master/SupplierBundleMaster"
import ProductBundle from "pages/Masters/Product-Bundle/ProductBundle"
import BarcodePrint from "pages/Utility/Barcode-Print/BarcodePrint"
import ProductBundleGroup from "pages/Masters/Product-Bundle-Group/ProductBundleGroup"
import TicketMaster from "pages/Masters/Ticket-Master/TicketMaster"
import InvoiceMaster from "pages/Masters/Invoice-Master/InvoiceMaster"
import ProductManage from "pages/Masters/Product-Manage-Master/ProductManage"
import TextFile from "pages/Masters/Text-Download/TextFile"
import NotificationApproval from "pages/Utility/Notification-Approvals/NotificationApproval"
import SearchDashboard from "pages/Utility/Search-Dashboard/SearchDashboard"
import ReportMaster from "pages/Utility/Report-Master/ReportMaster"
import LedgerMaster from "pages/Utility/Ledger-Master/LedgerMaster"
import BinMaster from "pages/Utility/Bin-Master/BinMaster";
import TestMaster from "pages/Masters/Test/TestMaster";
import ExcelUploadMaster from "pages/Utility/Excel-Upload-Master/ExcelUploadMaster";
import InboundCapacityMaster from "../pages/Masters/Inbound-Capacity-Master/InboundCapacityMaster"
import WMSBinMaster from "pages/Masters/WMSBin-Master/WMSBinMaster";
import TransactionExcelUpload from "pages/Transactions/TransactionExcelUpload/TransactionExcelUpload"
import SageIntergration from "pages/Utility/Sage-Intergration/SageIntergration";
import MealMaster from "pages/Masters/Meal-Master/MealMaster";
import TransactionGenerateTXNWithExcel from "pages/Transactions/Transaction-GenerateTXN-WithExcel/TransactionGenerateTXNWithExcel"
import ExcelFromSPMaster from "pages/Utility/ExcelFromSP-Master/ExcelFromSPMaster"
import TransactionUpdate from "pages/Transactions/Transaction-Update/TransactionUpdate"
import CustomStockFreeze from "pages/Transactions/CustomStockFreeze/CustomStockFreeze"
import TransactionCentralUpdate from "pages/Transactions/Transaction-Central-Update/TransactionCentralUpdate";
import JEPosting from "pages/Utility/JournalEntry-Posting/JEPosting";
import JournalViewMaster from "pages/Utility/Journal-View/JournalViewMaster";
import SystemConnections from "pages/Utility/SystemConnections/SystemConnections";
import MetaReportMaster from "pages/Utility/MetaReports/MetaReportMaster";

//Voucher Files
import VoucherGroup from "../pages/Vouchers/Voucher-Groups/VoucherGroup"
import VoucherPurchaseOrder from "../pages/Vouchers/Voucher-Purchase-orders/VoucherPurchaseOrder"
import VoucherGRN from "pages/Vouchers/Voucher-GRN/VoucherGRN"
import VoucherTransferIn from "pages/Vouchers/Voucher-TransferIn/VoucherTransferIn"
import VoucherTransferOut from "pages/Vouchers/Voucher-TransferOut/VoucherTransferOut"
import VoucherBarcodePrint from "pages/Vouchers/Voucher-Barcode-Print/VoucherBarcodePrint"
import VoucherWriteOff from "pages/Vouchers/VoucherWriteOff/VoucherWriteOff"
import VoucherSell from "pages/Vouchers/Voucher-Sell/VoucherSell";
import VoucherRequest from "pages/Vouchers/Voucher-Request/VoucherRequest";

//Payment Files
import CreditNote from "../pages/MyPayment/CreditNote"
import CashBook from "../pages/Masters/CashBook/CashBook"

//Utility Files

import CreateUser from "../pages/Utility/Create-User/createUser"
import UserPassword from "../pages/Utility/User-Password/userPassword"
import UserPolicies from "../pages/Utility/User-Policies/userPolices"
import BillOfMeterialMaster from "../pages/Utility/Bill-Of-Meterial/BillOfMeterialMaster"
import MonthEnd from "pages/Utility/Month-End/MonthEnd";
import ProcessExecution from "pages/Utility/Process-Execution/ProcessExecution";
import ScaleData from "pages/Utility/Scale-Data-Print/ScaleDataPrint";
import PasswordReset from "pages/Utility/Password-Reset/PasswordReset";
import CustomExcelUploadMaster from "pages/Utility/Custom-Excel-Upload/CustomExcelUploadMaster";
import DynamicUIFromSPMaster from "pages/Utility/DynamicUIFromSP-Master/DynamicUIFromSPMaster";
import myReports from "pages/Utility/My-Reports/myReports";

//Report Files

import StockReport from "../pages/Reports/StockReports"
import SalesReport from "../pages/Reports/SalesReport"
import VoucherReport from "../pages/Reports/VoucherReport"

// // Pages Component
import Chat from "../pages/Chat/Chat"

// // File Manager
import FileManager from "../pages/FileManager/index"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

// // Pages Calendar
// import Calendar from "../pages/Calendar/index"

// //Tasks
// import TasksList from "../pages/Tasks/tasks-list"
// import TasksKanban from "../pages/Tasks/tasks-kanban"
// import TasksCreate from "../pages/Tasks/tasks-create"

// // //Projects
// import ProjectsGrid from "../pages/Projects/projects-grid"
// import ProjectsList from "../pages/Projects/projects-list"
// import ProjectsOverview from "../pages/Projects/ProjectOverview/projects-overview"
// import ProjectsCreate from "../pages/Projects/projects-create"

// //Ecommerce Pages
// import EcommerceProducts from "../pages/Ecommerce/EcommerceProducts/index"
// import EcommerceProductDetail from "../pages/Ecommerce/EcommerceProducts/EcommerceProductDetail"
// import EcommerceOrders from "../pages/Ecommerce/EcommerceOrders/index"
// import EcommerceCustomers from "../pages/Ecommerce/EcommerceCustomers/index"
// import EcommerceCart from "../pages/Ecommerce/EcommerceCart"
// import EcommerceCheckout from "../pages/Ecommerce/EcommerceCheckout"
// import EcommerceShops from "../pages/Ecommerce/EcommerceShops/index"
// import EcommerceAddProduct from "../pages/Ecommerce/EcommerceAddProduct"

//Email
// import EmailInbox from "../pages/Email/email-inbox"
// import EmailRead from "../pages/Email/email-read"
// import EmailBasicTemplte from "../pages/Email/email-basic-templte"
// import EmailAlertTemplte from "../pages/Email/email-template-alert"
// import EmailTemplateBilling from "../pages/Email/email-template-billing"

// //Invoices
// import InvoicesList from "../pages/Invoices/invoices-list"
// import InvoiceDetail from "../pages/Invoices/invoices-detail"

// Authentication related pages
import Login from "../pages/Authentication/Login 24x"
import CargillsLogin from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

//  // Inner Authentication
// import Login1 from "../pages/AuthenticationInner/Login"
// import Login2 from "../pages/AuthenticationInner/Login2"
// import Register1 from "../pages/AuthenticationInner/Register"
// import Register2 from "../pages/AuthenticationInner/Register2"
// import Recoverpw from "../pages/AuthenticationInner/Recoverpw"
// import Recoverpw2 from "../pages/AuthenticationInner/Recoverpw2"
// import ForgetPwd1 from "../pages/AuthenticationInner/ForgetPassword"
// import ForgetPwd2 from "../pages/AuthenticationInner/ForgetPassword2"
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen"
import LockScreen2 from "../pages/AuthenticationInner/auth-lock-screen 247"
// import ConfirmMail from "../pages/AuthenticationInner/page-confirm-mail"
// import ConfirmMail2 from "../pages/AuthenticationInner/page-confirm-mail-2"
// import EmailVerification from "../pages/AuthenticationInner/auth-email-verification"
// import EmailVerification2 from "../pages/AuthenticationInner/auth-email-verification-2"
// import TwostepVerification from "../pages/AuthenticationInner/auth-two-step-verification"
// import TwostepVerification2 from "../pages/AuthenticationInner/auth-two-step-verification-2"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
import DashboardSaas from "../pages/Dashboard-saas/index"
import DashboardCrypto from "../pages/Dashboard-crypto/index"
import Blog from "../pages/Dashboard-Blog/index"

//Crypto
import CryptoWallet from "../pages/Crypto/CryptoWallet/crypto-wallet"
import CryptoBuySell from "../pages/Crypto/crypto-buy-sell"
import CryptoExchange from "../pages/Crypto/crypto-exchange"
import CryptoLending from "../pages/Crypto/crypto-lending"
import CryptoOrders from "../pages/Crypto/CryptoOrders/crypto-orders"
import CryptoKYCApplication from "../pages/Crypto/crypto-kyc-application"
import CryptoIcoLanding from "../pages/Crypto/CryptoIcoLanding/index"


// Charts
import ChartApex from "../pages/Charts/Apexcharts"
import ChartistChart from "../pages/Charts/ChartistChart"
import ChartjsChart from "../pages/Charts/ChartjsChart"
import EChart from "../pages/Charts/EChart"
import SparklineChart from "../pages/Charts/SparklineChart"
import ToastUIChart from "../pages/Charts/ToastUIChart"
import ChartsKnob from "../pages/Charts/charts-knob"
import ReCharts from "../pages/Charts/ReCharts"
// import ChartBuilder from "../pages/ChartBuilder";

// Maps
// import MapsGoogle from "../pages/Maps/MapsGoogle"
// import MapsVector from "../pages/Maps/MapsVector"
// import MapsLeaflet from "../pages/Maps/MapsLeaflet"

//Icons
// import IconBoxicons from "../pages/Icons/IconBoxicons"
// import IconDripicons from "../pages/Icons/IconDripicons"
// import IconMaterialdesign from "../pages/Icons/IconMaterialdesign"
// import IconFontawesome from "../pages/Icons/IconFontawesome"

//Tables
// import BasicTables from "../pages/Tables/BasicTables"
// import DatatableTables from "../pages/Tables/DatatableTables"
// import ResponsiveTables from "../pages/Tables/ResponsiveTables"
// import EditableTables from "../pages/Tables/EditableTables"
// import DragDropTables from "../pages/Tables/DragDropTables"

//Blog
// import BlogList from "../pages/Blog/BlogList/index"
// import BlogGrid from "../pages/Blog/BlogGrid/index"
// import BlogDetails from "../pages/Blog/BlogDetails"

// Forms
// import FormElements from "../pages/Forms/FormElements"
// import FormLayouts from "../pages/Forms/FormLayouts"
// import FormAdvanced from "../pages/Forms/FormAdvanced"
// import FormEditors from "../pages/Forms/FormEditors"
// import FormValidations from "../pages/Forms/FormValidations"
// import FormMask from "../pages/Forms/FormMask"
// import FormRepeater from "../pages/Forms/FormRepeater"
// import FormUpload from "../pages/Forms/FormUpload"
// import FormWizard from "../pages/Forms/FormWizard"
// import FormXeditable from "../pages/Forms/FormXeditable"
// import DualListbox from "../pages/Tables/DualListbox"

//Ui
// import UiAlert from "../pages/Ui/UiAlert"
// import UiButtons from "../pages/Ui/UiButtons"
// import UiCards from "../pages/Ui/UiCards"
// import UiCarousel from "../pages/Ui/UiCarousel"
// import UiColors from "../pages/Ui/UiColors"
// import UiDropdown from "../pages/Ui/UiDropdown"
// import UiGeneral from "../pages/Ui/UiGeneral"
// import UiGrid from "../pages/Ui/UiGrid"
// import UiImages from "../pages/Ui/UiImages"
// import UiLightbox from "../pages/Ui/UiLightbox"
// import UiModal from "../pages/Ui/UiModal"
// import UiProgressbar from "../pages/Ui/UiProgressbar"
// import UiSweetAlert from "../pages/Ui/UiSweetAlert"
// import UiTabsAccordions from "../pages/Ui/UiTabsAccordions"
// import UiTypography from "../pages/Ui/UiTypography"
// import UiVideo from "../pages/Ui/UiVideo"
// import UiSessionTimeout from "../pages/Ui/UiSessionTimeout"
// import UiRating from "../pages/Ui/UiRating"
// import UiRangeSlider from "../pages/Ui/UiRangeSlider"
// import UiNotifications from "../pages/Ui/ui-notifications"
import UiDrawer from "pages/Ui/UiDrawer"
// import UiBreadcrumb from "../pages/Ui/UiBreadcrumb"

//Pages
// import PagesStarter from "../pages/Utility-theme/pages-starter"
// import PagesMaintenance from "../pages/Utility-theme/pages-maintenance"
// import PagesComingsoon from "../pages/Utility-theme/pages-comingsoon"
// import PagesTimeline from "../pages/Utility-theme/pages-timeline"
// import PagesFaqs from "../pages/Utility-theme/pages-faqs"
// import PagesPricing from "../pages/Utility-theme/pages-pricing"
// import Pages404 from "../pages/Utility-theme/pages-404"
// import Pages500 from "../pages/Utility-theme/pages-500"

//Contacts
// import ContactsGrid from "../pages/Contacts/contacts-grid"
// import ContactsList from "../pages/Contacts/ContactList/contacts-list"
// import ContactsProfile from "../pages/Contacts/ContactsProfile/contacts-profile"

//DP Framework
// import Sample from "../framework/layout/Sample"
// import SampleUi from "../framework/layout/SampleUi"
// import SampleUi2 from "../framework/layout/SampleUi2"
// import PSampleUi2 from "../pages/Samples/SampleUi2"

import ViewAll from "components/CommonForBoth/TopbarDropdown/ViewAll"

const userRoutes = [
  { path: "/dashboard", component: Dashboard },
  { path: "/dashboard-saas", component: DashboardSaas },
  { path: "/dashboard-crypto", component: DashboardCrypto },
  { path: "/blog", component: Blog },

  //Crypto
  { path: "/crypto-wallet", component: CryptoWallet },
  { path: "/crypto-buy-sell", component: CryptoBuySell },
  { path: "/crypto-exchange", component: CryptoExchange },
  { path: "/crypto-lending", component: CryptoLending },
  { path: "/crypto-orders", component: CryptoOrders },
  { path: "/crypto-kyc-application", component: CryptoKYCApplication },

  //chat
  { path: "/chat", component: Chat },

  //File Manager
  { path: "/apps-filemanager", component: FileManager },

  // Master Files

  { path: "/VendorMaster", component: VendorMaster },
  { path: "/CustomerMaster", component: CustomerMaster },
  {
    path: "/CustomerDiscountGroupMaster",
    component: CustomerDiscountGroupMaster,
  },
  { path: "/LocationMaster", component: LocationMaster },
  { path: "/SalesExecutiveMaster", component: SalesExecutiveMaster },
  { path: "/SalesExecutiveGroupMaster", component: SalesExecutiveGroupMaster },
  { path: "/CustomerGroupMaster", component: CustomerGroupMaster },
  { path: "/PaymentMode", component: PaymentMode },
  { path: "/VendorGroup", component: VendorGroup },
  { path: "/TaxMaster", component: TaxMaster },
  { path: "/TransactionTypeMaster", component: TransactionTypeMaster },
  { path: "/UnitMaster", component: UnitMaster },
  { path: "/GroupMaster", component: GroupMaster },
  { path: "/ProductMaster", component: ProductMaster },
  { path: "/AreaMaster", component: AreaMaster },
  { path: "/SuplierTypeMaster", component: SuplierTypeMaster },
  { path: "/SuplierCategoryMaster", component: SuplierCategoryMaster },
  { path: "/DesignationMaster", component: DesignationMaster },
  { path: "/ProfessionMaster", component: ProfessionMaster },
  { path: "/EthnicityMaster", component: EthnicityMaster },
  { path: "/LanguageMaster", component: LanguageMaster },
  { path: "/ReligionMaster", component: ReligionMaster },
  { path: "/GroupMasterSetup", component: GroupMasterSetup },
  { path: "/LoyaltyGroupMaster", component: LoyaltyGroupMaster },
  { path: "/PriceModeMaster", component: PriceModeMaster },
  { path: "/PurchasingModeMaster", component: PurchasingModeMaster },
  { path: "/TitlesMaster", component: TitlesMaster },
  { path: "/ProviderMaster", component: ProviderMaster },
  { path: "/UserMaster", component: UserMaster },
  { path: "/UserGroupMaster", component: UserGroupMaster },
  { path: "/ReasonTypesMaster", component: ReasonTypesMaster },
  { path: "/CompanyMaster", component: CompanyMaster },
  { path: "/SizeMaster", component: SizeMaster },
  { path: "/ColorMaster", component: ColorMaster },
  { path: "/PromotionMaster", component: PromotionMaster },
  { path: "/PromotionGroup", component: PromotionGroupMaster },
  { path: "/CustomerBundleMaster", component: CustomerBundleMaster },
  { path: "/SupplierBundleMaster", component: SupplierBundleMaster },
  { path: "/ProductBundle", component: ProductBundle },
  { path: "/ProductBundleGroup", component: ProductBundleGroup },
  { path: "/TicketMaster", component: TicketMaster },
  { path: "/InvoiceMaster", component: InvoiceMaster },
  { path: "/ProductManage", component: ProductManage },
  { path: "/Text", component: TextFile },
  { path: "/NotificationApproval", component: NotificationApproval },
  { path: "/Ledger", component: LedgerMaster },
  { path: "/Bincard", component: BinMaster },
  { path: "/Test", component: TestMaster },
  { path: "/ExcelUpload", component: ExcelUploadMaster },
  { path: "/InboundCapacity", component: InboundCapacityMaster },
  { path: "/WMSBin", component: WMSBinMaster },
  { path: "/MealMaster", component: MealMaster },
  { path: "/ExcelFromSP", component: ExcelFromSPMaster },
  { path: "/JEPosting", component: JEPosting },
  { path: "/JournalView", component: JournalViewMaster },
  { path: "/my-reports", component: myReports },
  { path: "/SystemConnections", component: SystemConnections },
  { path: "/MetaReport", component: MetaReportMaster },


  //Transactions
  { path: "/Transaction", component: Transactions },
  { path: "/StockFreeze", component: StockFreeze },
  { path: "/TransactionExcelUpload", component: TransactionExcelUpload },
  { path: "/SageIntergration", component: SageIntergration },
  { path: "/TransactionGenerate", component: TransactionGenerateTXNWithExcel },
  { path: "/TransactionUpdate", component: TransactionUpdate },
  { path: "/CustomStockFreeze", component: CustomStockFreeze },
  { path: "/TransactionCentralUpdate", component: TransactionCentralUpdate },

  //Vouchers
  { path: "/VoucherGroup", component: VoucherGroup },
  { path: "/VoucherPurchaseOrder", component: VoucherPurchaseOrder },
  { path: "/VoucherGRN", component: VoucherGRN },
  { path: "/VoucherTransferOut", component: VoucherTransferOut },
  { path: "/VoucherTransferIn", component: VoucherTransferIn },
  { path: "/VoucherBarcodePrint", component: VoucherBarcodePrint },
  { path: "/VoucherWriteOff", component: VoucherWriteOff },
  { path: "/VoucherSell", component: VoucherSell },
  { path: "/VoucherRequest", component: VoucherRequest },

  { path: "/ViewAll", component: ViewAll },

  //Reports
  { path: "/StockReport", component: StockReport },
  { path: "/SalesReport", component: SalesReport },
  { path: "/VoucherReports", component: VoucherReport },

  //utility files

  // { path: "/CreateUser", component: CreateUser },
  { path: "/UserPassword", component: UserPassword },
  { path: "/UserPolicies", component: UserPolicies },
  { path: "/BillOfMeterial", component: BillOfMeterialMaster },
  { path: "/BarcodePrint", component: BarcodePrint },
  { path: "/MonthEnd", component: MonthEnd },
  { path: "/SearchDashboard", component: SearchDashboard },
  { path: "/Report", component: ReportMaster },
  { path: "/ProcessExecution", component: ProcessExecution },
  { path: "/ScaleData", component: ScaleData },
  { path: "/PasswordReset", component: PasswordReset },
  { path: "/CustomExcelUpload", component: CustomExcelUploadMaster },
  { path: "/DynamicUIFromSP", component: DynamicUIFromSPMaster },


  //MyPayment
  { path: "/CreditNote", component: CreditNote },
  { path: "/CashBook", component: CashBook },

  // //calendar
  // { path: "/calendar", component: Calendar },

  // //profile
  { path: "/profile", component: UserProfile },

  //Ecommerce
  // { path: "/ecommerce-product-detail/:id", component: EcommerceProductDetail },
  // { path: "/ecommerce-products", component: EcommerceProducts },
  // { path: "/ecommerce-orders", component: EcommerceOrders },
  // { path: "/ecommerce-customers", component: EcommerceCustomers },
  // { path: "/ecommerce-cart", component: EcommerceCart },
  // { path: "/ecommerce-checkout", component: EcommerceCheckout },
  // { path: "/ecommerce-shops", component: EcommerceShops },
  // { path: "/ecommerce-add-product", component: EcommerceAddProduct },

  //Email
  // { path: "/email-inbox", component: EmailInbox },
  // { path: "/email-read", component: EmailRead },
  // { path: "/email-template-basic", component: EmailBasicTemplte },
  // { path: "/email-template-alert", component: EmailAlertTemplte },
  // { path: "/email-template-billing", component: EmailTemplateBilling },

  //Invoices
  // { path: "/invoices-list", component: InvoicesList },
  // { path: "/invoices-detail/:id?", component: InvoiceDetail },

  // Tasks
  // { path: "/tasks-list", component: TasksList },
  // { path: "/tasks-kanban", component: TasksKanban },
  // { path: "/tasks-create", component: TasksCreate },

  //Projects
  // { path: "/projects-grid", component: ProjectsGrid },
  // { path: "/projects-list", component: ProjectsList },
  // { path: "/projects-overview", component: ProjectsOverview },
  // { path: "/projects-overview/:id", component: ProjectsOverview },
  // { path: "/projects-create", component: ProjectsCreate },

  //Blog
  // { path: "/blog-list", component: BlogList },
  // { path: "/blog-grid", component: BlogGrid },
  // { path: "/blog-details", component: BlogDetails },

  // Contacts
  // { path: "/contacts-grid", component: ContactsGrid },
  // { path: "/contacts-list", component: ContactsList },
  // { path: "/contacts-profile", component: ContactsProfile },

  // Charts
  { path: "/apex-charts", component: ChartApex },
  { path: "/chartist-charts", component: ChartistChart },
  { path: "/chartjs-charts", component: ChartjsChart },
  { path: "/e-charts", component: EChart },
  { path: "/sparkline-charts", component: SparklineChart },
  { path: "/tui-charts", component: ToastUIChart },
  { path: "/charts-knob", component: ChartsKnob },
  { path: "/re-charts", component: ReCharts },
  // { path: "/chart-builder/*", component: ChartBuilder },

  // Icons
  // { path: "/icons-boxicons", component: IconBoxicons },
  // { path: "/icons-dripicons", component: IconDripicons },
  // { path: "/icons-materialdesign", component: IconMaterialdesign },
  // { path: "/icons-fontawesome", component: IconFontawesome },

  // Tables
  // { path: "/tables-basic", component: BasicTables },
  // { path: "/tables-datatable", component: DatatableTables },
  // { path: "/tables-responsive", component: ResponsiveTables },
  // { path: "/tables-editable", component: EditableTables },
  // { path: "/tables-dragndrop", component: DragDropTables },

  // Maps
  // { path: "/maps-google", component: MapsGoogle },
  // { path: "/maps-vector", component: MapsVector },
  // { path: "/maps-leaflet", component: MapsLeaflet },

  // Forms
  // { path: "/form-elements", component: FormElements },
  // { path: "/form-layouts", component: FormLayouts },
  // { path: "/form-advanced", component: FormAdvanced },
  // { path: "/form-editors", component: FormEditors },
  // { path: "/form-mask", component: FormMask },
  // { path: "/form-repeater", component: FormRepeater },
  // { path: "/form-uploads", component: FormUpload },
  // { path: "/form-wizard", component: FormWizard },
  // { path: "/form-validation", component: FormValidations },
  // { path: "/form-xeditable", component: FormXeditable },
  // { path: "/dual-listbox", component: DualListbox },

  // Ui
  // { path: "/ui-alerts", component: UiAlert },
  // { path: "/ui-buttons", component: UiButtons },
  // { path: "/ui-cards", component: UiCards },
  // { path: "/ui-carousel", component: UiCarousel },
  // { path: "/ui-colors", component: UiColors },
  // { path: "/ui-dropdowns", component: UiDropdown },
  // { path: "/ui-general", component: UiGeneral },
  // { path: "/ui-grid", component: UiGrid },
  // { path: "/ui-images", component: UiImages },
  // { path: "/ui-lightbox", component: UiLightbox },
  // { path: "/ui-modals", component: UiModal },
  // { path: "/ui-progressbars", component: UiProgressbar },
  // { path: "/ui-sweet-alert", component: UiSweetAlert },
  // { path: "/ui-tabs-accordions", component: UiTabsAccordions },
  // { path: "/ui-typography", component: UiTypography },
  // { path: "/ui-video", component: UiVideo },
  // { path: "/ui-session-timeout", component: UiSessionTimeout },
  // { path: "/ui-rating", component: UiRating },
  // { path: "/ui-rangeslider", component: UiRangeSlider },
  // { path: "/ui-notifications", component: UiNotifications },
  // { path: "/ui-drawer", component: UiDrawer },
  // { path: "/ui-breadcrumb", component: UiBreadcrumb },

  //Utility
  // { path: "/pages-starter", component: PagesStarter },
  // { path: "/pages-timeline", component: PagesTimeline },
  // { path: "/pages-faqs", component: PagesFaqs },
  // { path: "/pages-pricing", component: PagesPricing },

  // { path: "/pages-dp_sampleui2", component: PSampleUi2 },

  // this route should be at the end of all other routes
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
]

const authRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: (!ActiveClient || ActiveClient == 'cargills') ? CargillsLogin : Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/register", component: Register },

  // { path: "/pages-maintenance", component: PagesMaintenance },
  // { path: "/pages-comingsoon", component: PagesComingsoon },
  // { path: "/pages-404", component: Pages404 },
  // { path: "/pages-500", component: Pages500 },
  // { path: "/crypto-ico-landing", component: CryptoIcoLanding },

  // // Authentication Inner
  // { path: "/pages-login", component: Login1 },
  // { path: "/pages-login-2", component: Login2 },
  // { path: "/pages-register", component: Register1 },
  // { path: "/pages-register-2", component: Register2 },
  // { path: "/page-recoverpw", component: Recoverpw },
  // { path: "/page-recoverpw-2", component: Recoverpw2 },
  // { path: "/pages-forgot-pwd", component: ForgetPwd1 },
  // { path: "/auth-recoverpw-2", component: ForgetPwd2 },
  { path: "/auth-lock-screen", component: (!ActiveClient || ActiveClient == "cargills") ? LockScreen : LockScreen2 },
  // { path: "/page-confirm-mail", component: ConfirmMail },
  // { path: "/page-confirm-mail-2", component: ConfirmMail2 },
  // { path: "/auth-email-verification", component: EmailVerification },
  // { path: "/auth-email-verification-2", component: EmailVerification2 },
  // { path: "/auth-two-step-verification", component: TwostepVerification },
  // { path: "/auth-two-step-verification-2", component: TwostepVerification2 },

  // //DP Framework
  // { path: "/dp_sample", component: Sample },
  // { path: "/dp_sampleui", component: SampleUi },
  // { path: "/dp_sampleui2", component: SampleUi2 },
]

export { userRoutes, authRoutes }
